module.exports = __webpack_public_path__ + "img/Portretul_lui_Stefan_cel_Mare_Tetraevanghel_1474_f266v.9659d09c.jpg";